var PIXI = require('pixi.js');

var pcount = 0;
var particles = {};

var Particle = function(game, img) {
    this.idx = pcount++;
    particles[this.idx] = this;
    this.start = Date.now();
    this.img = img;
    this.sprite = new PIXI.Sprite(this.img);
    this.sprite.scale.set(.3333, .3333);
    this.sprite.anchor.x = .5;
    this.sprite.anchor.y = .5;
    this.game = game;
    this.game.stage.addChild(this.sprite);
};

(function() {
    this.reset = function(x, y, mx, my, s, ms, o, mo, a, ma) {
        this.start = Date.now();
        this.x = x;
        this.y = y;
        this.mx = mx;
        this.my = my;
        this.s = s;
        this.ms = ms;
        this.o = o;
        this.mo = mo;
        this.a = a;
        this.ma = ma;
        this.animate(0, this.start);
    };

    this.destroy = function () {
        this.game.stage.removeChild(this.sprite);
    };

    this.animate = function(dt, now) {
        this.x = this.x + this.mx * dt / .6;
        this.y = this.y + this.my * dt / .6;
        this.s = this.s + this.ms * dt;
        this.o = this.o + this.mo * dt;
        this.a = this.a + this.ma * dt;
        if (this.game.platform.goal) {
            var pl = this.game.platform.goal;
            var halfwidth = this.game.platform.goal.width / 2;
            var halfheight = this.game.platform.goal.height / 2;
            if (this.x > pl.x - halfwidth
                && this.x < pl.x + halfwidth  
                && this.y > pl.y - halfheight
                && this.y < pl.y + halfheight) {
                this.my = 0;
                this.mx = Math.random() * 100 - 50;
                this.y = pl.y - halfheight;
            }
        }
        if(this.y > this.game.height - 3) {
            this.my = 0;
            this.mx = this.mx = Math.random() * 200 - 100;
            this.y = this.game.height - 3;
            //delete particles[pcount];
        }
        if(now - this.start > 5000 || this.o <= 0) {
            this.destroy();
            delete particles[this.idx];
            return;
        }
        if (this.s <= 0) {
            this.destroy();
            delete particles[this.idx];
            return;
        }
        this.sprite.alpha = this.o;
        this.sprite.position.x = this.x;
        this.sprite.position.y = this.y;
        this.sprite.rotation = this.a;
        this.sprite.scale.set(this.s, this.s);
    }
}).call(Particle.prototype);

module.exports = {Particle: Particle, particles: particles};



//////////////////
// WEBPACK FOOTER
// ./src/particle.js
// module id = 22
// module chunks = 0